module.exports = __webpack_public_path__ + "img/pad.fdb0e449.png";